module.exports = __webpack_public_path__ + "img/bg_service_normal.d4a82e6c.png";